<template>
  <div class="ablitySet">
    <div class="ablityTable">
      <div class="btns" v-permission="`Content.QuestiongroupSeting.Ability.Add`">
        <a-button @click="addAblity()" type="primary" class="addAblity" icon="plus">添加能力</a-button>
      </div>
      <a-table :columns="columns" rowKey="id" :loading="table.tableLoading" :dataSource="table.tableDataSource" :pagination="table.tablePagination">
        <div slot="code" slot-scope="text, record">
          <a-select style="width: 172px" show-search :filter-option="filterOption" @change="handleChange" :key="record.code" :default-value="record.code">
            <a-select-option :value="item" v-for="item in codesList" :key="item.id" @click="getRecord(record)">{{ item }}</a-select-option>
          </a-select>
        </div>
        <div slot="action" slot-scope="text, record">
          <a @click="editAbility(record)" style="margin-left: 15px" v-permission="`Content.QuestiongroupSeting.Ability.Edit`"><a-icon type="edit" />编辑</a>
          <a-popconfirm title="确定删除？" v-permission="`Content.QuestiongroupSeting.Ability.Delete`" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(record)" style="margin-left: 15px">
            <a style="color: #f00"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
          <a v-permission="`Content.QuestiongroupSeting.Ability.Model`" @click="normSeting(record)" v-if="record.codeBindId" style="margin-left: 15px">常模配置</a>
          <a v-permission="`Content.QuestiongroupSeting.Ability.Model`" class="noClick" style="margin-left: 15px" v-else>常模配置</a>
        </div>
      </a-table>
    </div>
    <!-- 编辑添加能力 -->
    <a-modal v-model="isAbility" :title="modelTit" @ok="addAbilityOk" @cancel="closeModle">
      <a-form-model ref="ruleForm" :model="abilityForm" :rules="abilityRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="abilityTypeId" label="能力类型" prop="abilityTypeId">
          <a-select v-model="abilityForm.abilityTypeId" placeholder="请选择能力类型" @change="abilityTypeChange">
            <a-select-option :value="item.id" :text="item.name" v-for="item in abilityType" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="firstAbilityId" label="一级能力" prop="firstAbilityId">
          <a-select v-model="abilityForm.firstAbilityId" placeholder="请选择一级能力" @change="firstAbilityChange">
            <a-select-option :value="item.id" :text="item.name" v-for="item in firstAbility" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="secondAbilityId" label="二级能力" prop="secondAbilityId">
          <a-select v-model="abilityForm.secondAbilityId" placeholder="请选择二级能力" @change="secondAbilityChange">
            <a-select-option :value="item.id" :text="item.name" v-for="item in secondAbility" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="scientificName" label="科学名称" prop="scientificName">
          <a-input v-model="abilityForm.scientificName" />
        </a-form-model-item>
        <a-form-model-item ref="roughDescription" label="粗分说明" prop="roughDescription">
          <a-input v-model="abilityForm.roughDescription" type="textarea" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils"
const columns = [
  {
    title: "能力类型",
    dataIndex: "abilityTypeName",
    align: "center"
  },
  {
    title: "一级能力",
    dataIndex: "firstAbilityName",
    align: "center"
  },
  {
    title: "二级能力",
    dataIndex: "secondAbilityName",
    align: "center"
  },
  {
    title: "科学名称",
    dataIndex: "scientificName",
    align: "center"
  },
  {
    title: "粗分说明",
    width:450,
    dataIndex: "roughDescription",
    align: "center"
  },
  {
    title: "算分码",
    align: "center",
    scopedSlots: { customRender: "code" }
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
export default {
  name: "ablitySet",
  data() {
    return {
      type:'',
      columns: columns,
        table: tableRelevant.call(this),
      loading: false,
      dataSource: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      isAbility:false,
      abilityForm:{
        contentId:'',
        abilityTypeId:'',
        abilityTypeName:'',
        firstAbilityId:'',
        firstAbilityName:'',
        secondAbilityId:'',
        secondAbilityName:'',
        scientificName:'',
        roughDescription:'',
      },
      abilityRules: {
        abilityTypeId: [{ required: true, message: '请选择能力类型', trigger: 'change' }],
        firstAbilityId: [{ required: true, message: '请选择一级能力', trigger: 'change' }],
        secondAbilityId: [{ required: true, message: '请选择二级能力', trigger: 'change' }],
        scientificName: [
          { required: true, message: '请填写科学名称', trigger: 'blur' },
          {min: 2, max: 30, message: '科学名称长度为 2 到 30 个字符', trigger: 'blur'}
        ],
        roughDescription: [
          { required: true, message: '请填写粗分说明', trigger: 'blur' },
          { max: 200, message: '粗分说明最大长度为 200 个字符', trigger: 'blur'}
        ],
      },
      abilityType:[],
      firstAbility:[],
      secondAbility:[],
      modelTit:'',
      currentId: this.$store.getters["content/getQuestionGroupInfo"]().id,

      codesList:[],//算分码列表
      selectCodeId:'',//选择算分码id
      contentAbilityId:'',//能力id
      ContentVersionId:''
    };
  },
  watch:{
    isAbility(){
      if(!this.isAbility){
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  created() {
    console.log(this.currentId);
    this.abilityTypeSelect(0)

    this.getAllCodes()
    this.getDetailByid()

  },
  methods: {
    getDetailByid(){
      let params = {
        id:this.currentId
      }
      this.$http.GetTrainingContentDetail(params)
      .then(res => {
            this.contentVersionId = res.data.contentVersionId
            this.getAbilityListByVersionId()

      });
    },
    closeModle(){
      this.$refs.ruleForm.resetFields();
    },
      getAbilityListByVersionId(page) {
          let params = {
              ContentId: this.currentId,
              ContentVersionId: this.contentVersionId,
              pageIndex: 1,
              pageSize: 9999,
          };
          this.table.tableLoading = true;
          this.$http.getAbilityListByVersionId(params).then(res => {
              this.table.tableLoading = false;
              const {status, data, message} = res.data;
                  this.table.tableDataSource = data

          });
      },
    abilityTypeSelect(level){
      let params = {
        level:level,
        abilityType:0,
      };
      this.$http.abilitySelect(params)
      .then(res => {
          this.abilityType = res.data.data
      });
    },
    firstAbilitySelect(id){
      let params = {
        pid:id,
        abilityType:0
      };
      this.$http.abilitySelect(params)
      .then(res => {
          this.firstAbility = res.data.data
      });
    },
    secondAbilitySelect(id){
      let params = {
        pid:id,
        abilityType:0
      };
      this.$http.abilitySelect(params)
      .then(res => {
          this.secondAbility = res.data.data
      });
    },
    // 选中能力类型
    abilityTypeChange(value,option){
      this.abilityForm.firstAbilityId = ''
      this.abilityForm.secondAbilityId = ''
      this.abilityForm.abilityTypeName = option.data.attrs.text
      this.firstAbilitySelect(value)
      this.secondAbility = []
    },
    // 选中一级能力
    firstAbilityChange(value,option){
      this.abilityForm.secondAbilityId = ''
      this.abilityForm.firstAbilityName = option.data.attrs.text
      this.secondAbilitySelect(value)
    },
    // 选中二级能力
    secondAbilityChange(value,option){
      this.abilityForm.secondAbilityName = option.data.attrs.text
    },
    addAblity(){
      this.isAbility = true
      this.type = 'add'
      this.modelTit = '添加能力'
    },
    editAbility(record){
      this.type = 'edit'
      this.modelTit = '编辑能力'
      this.isAbility = true
      this.firstAbilitySelect(record.abilityTypeId)
      this.secondAbilitySelect(record.firstAbilityId)
      // this.abilityForm = record
      this.abilityForm = {
        abilityTypeId:record.abilityTypeId,
        abilityTypeName:record.abilityTypeName,
        firstAbilityId:record.firstAbilityId,
        firstAbilityName:record.firstAbilityName,
        secondAbilityId:record.secondAbilityId,
        secondAbilityName:record.secondAbilityName,
        scientificName:record.scientificName,
        roughDescription:record.roughDescription,
        id:record.id,
      }
    },
    addAbilityOk(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.abilityForm.contentId = this.currentId
          if(this.type == 'add'){
            this.$http.addAbility(this.abilityForm)
            .then(res => {
                this.isAbility = false
                this.$message.destroy();
                this.$message.success('添加成功');
                this.getAbilityListByVersionId()

            });
          }else{
            this.$http.updataAbility(this.abilityForm)
            .then(res => {
                this.isAbility = false
                this.$message.destroy();
                this.$message.success('修改成功');
                this.getAbilityListByVersionId()

            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteRecord(record){
      let formData = new FormData()
      formData.append('id',record.id)
      this.$http.deleteAbility(formData)
      .then(res => {
          this.$message.success('删除成功');
          this.getAbilityListByVersionId()
      });
    },

    // 算分码
    // 获取全部算分码
    getAllCodes(){
      this.$http.getAllCodes()
      .then(res => {
          this.codesList = res.data.data
      });
    },
    getRecord(record){
        this.selectCodeId = record.codeBindId
        this.contentAbilityId = record.id
    },
    // 算分码下拉框选中
    handleChange(value) {
      this.bindCode(value)
    },
    // 绑定算分码
    bindCode(code){
      let params = {
        id:this.selectCodeId,//选中算分码id
        contentAbilityId:this.contentAbilityId,//选中能力数据id
        contentVersionId:this.contentVersionId,//选中版本数据的id
        contentId:+this.currentId,
        algorithmCode:code,//选中的算分码
      }
      this.$http.bindCode(params)
      .then(res => {
          this.$message.success(res.data.message);
          this.getAbilityListByVersionId()

      });
    },
    // 算分码下拉框搜索
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 常模配置
    normSeting(record){
      this.$store.commit("content/setAbilityInfo", record);
      this.$router.push({
        path: "/content/normSeting",
        query: {
          id: record.id,
          name: record.name,
          type:'question',
          version:'1.0.0',
          ContentAlgorithmCodeConfigId:record.codeBindId,
          contentId:this.currentId
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.ablitySet {
  width: 100%;
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  .btns {
    width: 100%;
    display: flex;
    margin-bottom: 15px;
  }
  .noClick {
    color: #ccc;
    cursor: default;
  }
}
</style>
